import { getNotificationStatusByProductIdAction } from '@/actions/products/get-notification-status-by-product-id-action'
import { getPopularProductsByIdAction } from '@/actions/products/get-popular-products-by-id-action'
import { getProductByIdAction } from '@/actions/products/get-product-by-id-action'
import { getProductHistoriesByIdAction } from '@/actions/products/get-product-histories-by-id-action'
import { getProductOptionsByIdAction } from '@/actions/products/get-product-options-by-id-action'
import { getCurrentUserAction } from '@/actions/users/get-current-user-action'
import { createQueryKeyStore } from '@lukemorales/query-key-factory'

/**
 * Query Key를 관리하는 store
 * @link https://github.com/lukemorales/query-key-factory
 */

export const queries = createQueryKeyStore({
  user: {
    currentUser: () => ({
      queryKey: ['user', 'currentUser'],
      queryFn: async () => {
        const result = await getCurrentUserAction()
        if (result.type === 'error') {
          throw new Error(result.error)
        }

        return result.data
      },
    }),
  },
  products: {
    detail: (id: string) => ({
      queryKey: [{ id }],
      queryFn: async () => {
        const result = await getProductByIdAction({ id })
        if (result.type === 'error') {
          throw new Error(result.error)
        }
        return result.data
      },
    }),
    popular: (id: string) => ({
      queryKey: [{ id }],
      queryFn: async () => {
        const result = await getPopularProductsByIdAction({ id })
        if (result.type === 'error') {
          throw new Error(result.error)
        }

        return result.data
      },
    }),
    options: (id: string) => ({
      queryKey: [{ id }],
      queryFn: async () => {
        const result = await getProductOptionsByIdAction({ id })
        if (result.type === 'error') {
          throw new Error(result.error)
        }
        //TODO: api 수정시 아래 로직 불필요 - backend api 방어 로직
        return {
          ...result.data,
          results: result.data.results.filter((option) => !!option),
        }
      },
    }),
    notificationStatus: (id: string) => ({
      queryKey: [{ id }],
      queryFn: async () => {
        const result = await getNotificationStatusByProductIdAction({ id })
        if (result.type === 'error') {
          throw new Error(result.error)
        }
        return result.data
      },
    }),
    histories: ({
      id,
      stateDate,
      endDate,
    }: {
      id: string
      stateDate: string
      endDate: string
    }) => ({
      queryKey: [{ id, stateDate, endDate }],
      queryFn: async () => {
        const result = await getProductHistoriesByIdAction({
          id,
          stateDate,
          endDate,
        })
        if (result.type === 'error') {
          throw new Error(result.error)
        }
        return result.data
      },
    }),
  },
})
